module.exports = __webpack_public_path__ + "media/images/weather/61_night_g-1f6659c81d377bbb1a11d2dc2348e62a.png";